import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Opens the shell-hosted {@link PageHowToComponent} from toolbar buttons on individual routes
 * (list/detail toolbars are destroyed on navigation; the panel lives in `layout-basic`).
 */
@Injectable({ providedIn: 'root' })
export class PageHowToToolbarService {
  private readonly openSubject = new Subject<void>();
  readonly openRequested$ = this.openSubject.asObservable();

  requestOpen(): void {
    this.openSubject.next();
  }
}
